import { SessionBaseComponent } from './../../../../shared/components/session.base.component';
import { Injector, OnChanges, Output, SimpleChanges } from '@angular/core';
import { EventEmitter, Input } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { isNullOrEmpty } from 'src/app/core/utils/common-functions';
import { BaseComponent } from 'src/app/shared/components/base.component';
import { DeliveryOrderService } from '../../services/delivery-order.service';

@Component({
  selector: 'laas-drop-ctn-modiy',
  templateUrl: './drop-ctn-modiy.component.html',
  styleUrls: ['./drop-ctn-modiy.component.scss']
})
export class DropCtnModiyComponent extends SessionBaseComponent implements OnInit, OnChanges {
  @Input() display: boolean;
  @Input() dropDO: any;
  @Output() modalClosed: EventEmitter<boolean>;
  form: FormGroup;
  submitted: boolean;
  model: any;

  constructor(
    injector: Injector,
    private fb: FormBuilder,
    private DOService: DeliveryOrderService
  ) {
    super(injector);
    this.submitted = false;
    this.display = false;
    this.dropDO = null;
    this.form = this.fb.group({
      dropType: [null, Validators.required],
      //cartonCnt: [null, Validators.compose([Validators.min(1), Validators.required])],
      cartonCntTmp: [null, Validators.compose([Validators.min(1), Validators.required])],
      totalGrossWeight: [null, Validators.compose([Validators.min(0)])],
      totalNetWeight: [null, Validators.compose([Validators.min(0)])],
      volumeWeight: [null, Validators.compose([Validators.min(0)])]
    },
    {
      // Used custom form validator name
      validator: this.togetherRequired("totalGrossWeight", "volumeWeight")
    });
    this.model = { dropType: null, cartonCnt: null, totalGrossWeight: null, totalNetWeight: null, volumeWeight: null };
    this.modalClosed = new EventEmitter<boolean>();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.logger.info(changes);
    if (!isNullOrEmpty(changes.dropDO.currentValue)) {
      this.model.dropType = changes.dropDO.currentValue.dropType;
      this.model.cartonCnt = changes.dropDO.currentValue.cartonCnt;
      this.model.cartonCntTmp = changes.dropDO.currentValue.cartonCnt;
      this.model.totalGrossWeight = changes.dropDO.currentValue.totalGrossWeight;
      this.model.totalNetWeight = changes.dropDO.currentValue.totalNetWeight;
      this.model.volumeWeight = changes.dropDO.currentValue.volumeWeight;
    }
  }

  private togetherRequired(
    firstValue: string,
    secondValue: string
  ) {
    return (formGroup: FormGroup) => {
      const first = formGroup.controls[firstValue];
      const second = formGroup.controls[secondValue];

      if(
        (isNullOrEmpty(first.value) && isNullOrEmpty(second.value)) ||
        (!isNullOrEmpty(first.value) && !isNullOrEmpty(second.value))
      ){
        first.setErrors(null);
        second.setErrors(null);
      }

      if(!isNullOrEmpty(first.value) && isNullOrEmpty(second.value)){
        second.setErrors({ required: true });
      }

      if(!isNullOrEmpty(second.value) && isNullOrEmpty(first.value)){
        first.setErrors({ required: true });
      }
    };
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();
    // this.model = {
    //   dropType: this.dropDO.dropType,
    //   cartonCnt: this.dropDO.cartonCnt
    // };
  }

  modalConfirmBtnClick(event: any): void {
    this.submitted = true;
    if (this.form.invalid) {
      return;
    }

    this.DOService.updateDropTypeAndCartonCntByDONo(
      this.dropDO.doNo,
      this.model.dropType,
      this.model.cartonCntTmp,
      this.model.totalGrossWeight,
      this.model.totalNetWeight,
      this.model.volumeWeight,
      this.userProfile.loginAccount)
      .subscribe({
        next: () => {
          this.translateService.get('Common.Message.SuccessSave')
            .subscribe({
              next: msg => {
                this.toastService.success(msg);
                this.dropDO.dropType = this.model.dropType;
                this.dropDO.cartonCnt = this.model.cartonCntTmp;
                this.dropDO.totalGrossWeight = this.model.totalGrossWeight;
                this.dropDO.totalNetWeight = this.model.totalNetWeight;
                this.dropDO.volumeWeight = this.model.volumeWeight;
              }
            });
          this.display = false;
        }
      });
  }

  modalCancelBtnClick(event: any): void {
    this.display = false;
  }

  hideModal(event: any): void {
    this.modalClosed.emit(this.display);
  }
}

